import Login from "./Login";

const RequireAuth: FC<{ children: React.ReactElement }> = ({ children }) => {
    if (localStorage.getItem("mobile") === null || localStorage.getItem("token") === null || localStorage.getItem("token") === undefined || localStorage.getItem("mobile") === undefined) {
        return <Login />;
    }
    return children;
};

export default RequireAuth